"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Scale, BookOpen, Lock } from "lucide-react";
export default function OurCorePromise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const coreValues = [{
    title: "Legal Precision",
    description: "Our legal interpreters ensure every word is captured with absolute accuracy, maintaining the integrity of judicial proceedings and attorney-client privilege.",
    icon: Scale
  }, {
    title: "Medical Expertise",
    description: "Specialized terminology and cultural nuance are critical in healthcare. Our team bridges the gap between providers and patients with professional clarity.",
    icon: BookOpen
  }, {
    title: "Secure Protocols",
    description: "Operating in 100% secure environments with HIPAA-compliant infrastructure to protect sensitive information in high-pressure situations.",
    icon: Lock
  }];
  return;
}